module.exports = __webpack_public_path__ + "img/down-arrow.6465ee38.svg";